import { getVueTemplate } from "../../_imports/utils/utils.common";

export default {
	name: 'forms-field-label',
	template: getVueTemplate('forms-field-label'),
    props: {
		labelFor: String,
		label: String,
		isActive: Boolean,
		isRequired: Boolean
	},
	inject: [
        'getForm'
    ],
	computed: {
		aboveFields() {
            return this.form.data.labelsAboveFields;
        },
		form() {
			return this.getForm();
		}
    },
	methods: {
		getLabel() {
			let label = this.label;

			if (this.isRequired) {
				label += '*';
			}

			return label;
		}
	}
};